<template>
  <div class="mb-5">
    <v-card>
      <v-card-title>
        <div>
          <p class="d-flex">
            <v-chip outlined label>
              {{ invitation.manuscript.type }}
            </v-chip>
          </p>
          <h3 class="paper-title">{{ invitation.manuscript.title }}</h3>
          <div class="mt-2" v-if="invitation.note">
            <small>
              <strong class="red--text">Note:&nbsp;</strong>
              <i>{{ invitation.note }}</i>
            </small>
          </div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <!-- <v-card-text>
      <h4>Abstract</h4>
     
      <p>
        <strong class="label mr-2">Keywords:</strong>
        <v-chip
          small
          :key="word"
          color="green lighten-4"
          class="mr-1 my-1"
          v-for="word in invitation.manuscript.keywords"
        >
          {{ word }}
        </v-chip>
      </p>
    </v-card-text>
    <v-divider></v-divider> -->
      <!-- <v-card-actions class="px-4 py-3"> -->
      <div class="pa-3">
        <div>
          <v-btn
            depressed
            color="green accent-4"
            class="white--text ma-1"
            :loading="accepting"
            :disabled="accepting"
            @click="acceptInvitation"
          >
            Accept Invitation
          </v-btn>
        </div>
        <div class="d-flex">
          <v-btn
            outlined
            color="teal"
            class="ma-1"
            :disabled="suggesting"
            @click="suggestDialog = true"
          >
            Suggest <span v-if="$vuetify.breakpoint.mdAndUp">Reviewer</span>
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="ma-1"
            :disabled="declining"
            @click="declineDialog = true"
          >
            Decline
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </div>
      </div>
      <!-- </v-card-actions> -->

      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>

          <v-card-text>
            <h4>Abstract</h4>
            <div class="abstract" v-html="invitation.manuscript.abstract"></div>

            <p class="my-2">
              <strong class="label mr-2">Keywords:</strong>
              <v-chip
                small
                :key="word"
                color="green lighten-4"
                class="mr-1 my-1"
                v-for="word in invitation.manuscript.keywords"
              >
                {{ word }}
              </v-chip>
            </p>
            <v-divider></v-divider>
            <h4 class="my-2">Authors</h4>
            <ol>
              <li
                :key="author.id"
                v-for="author in invitation.manuscript.authors"
              >
                {{ author.title }} {{ author.firstName }} {{ author.lastName }}
                <br />
                <i> {{ author.institution }}</i>
              </li>
            </ol>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
    <DeclineInvitation
      :open="declineDialog"
      @cancel="declineDialog = false"
      @confirm="declineInvitation"
    />
    <SuggestReviewer
      :open="suggestDialog"
      @cancel="suggestDialog = false"
      @suggest="suggestReviewer"
    />
  </div>
</template>

<script>
import { formatDate } from "../../../tools/format";
import DeclineInvitation from "../Dialog/DeclineInvitation";
import SuggestReviewer from "../Dialog/SuggestReviewer";

export default {
  props: {
    invitation: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    DeclineInvitation,
    SuggestReviewer,
  },

  data: () => ({
    show: false,
    accepting: false,
    declining: false,
    suggesting: false,
    declineDialog: false,
    suggestDialog: false,
  }),

  methods: {
    formatDate,

    declineInvitation() {
      if (!this.declining) {
        this.declining = true;
        this.$axios
          .put(`/invitations/reject?invitation=${this.invitation._id}`)
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Invitation has been declined",
            });
            this.declineDialog = false;
            this.$bus.$emit("invitations.reload");
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not reject invitation",
            });
          })
          .finally(() => {
            this.declining = false;
          });
      }
    },
    acceptInvitation() {
      if (!this.accepting) {
        this.accepting = true;
        this.$axios
          .put(`/invitations/accept?invitation=${this.invitation._id}`)
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Invitation has been accepted",
            });
            this.$bus.$emit("invitations.reload");
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not accept invitation",
            });
          })
          .finally(() => {
            this.accepting = false;
          });
      }
    },
    suggestReviewer(reviewer) {
      if (!this.suggesting) {
        this.suggesting = true;
        this.$axios
          .put(
            `/invitations/suggest?invitation=${this.invitation._id}`,
            reviewer
          )
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Suggestion has been submitted",
            });
            this.suggestDialog = false;
            this.$bus.$emit("invitations.reload");
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not submit suggestion",
            });
          })
          .finally(() => {
            this.suggesting = false;
          });
      }
    },
  },
};
</script>

<style scoped >
.paper-title {
  word-break: keep-all;
}
</style>